import { useContext, useCallback } from 'react';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

const useUpdateDataRoomCapacity = () => {
  const {
    dataRoom: { _id },
    setDataRoom,
  } = useContext(DataRoomContext);

  const updateDataRoomCapacity = useCallback(async () => {
    const {
      data: { storageCapacityUtilization },
    } = await dataRoomApi.room.getStorageCapacityUtilization(_id);

    if (storageCapacityUtilization)
      setDataRoom((old) => ({ ...old, storageCapacityUtilization }));
  }, [_id, setDataRoom]);

  return updateDataRoomCapacity;
};

export default useUpdateDataRoomCapacity;
